import React from 'react';

import { Overlay } from 'office-ui-fabric-react/lib/Overlay';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { localizable } from 'components/Localization';

import './style.css';

const OverlayMessage = ({
  iconName,
  message = '',
  buttonLabel,
  t,
  onClick = () => { },
}) => {
  return (
    <Overlay>
      <div className="overlay">
        <div className="overlay-line">
          <Icon iconName={iconName} className={`overlay-icon ${iconName}`} />
        </div>
        <div className="overlay-line">{message}</div>
        <div className="overlay-line">
          <PrimaryButton onClick={onClick}>{buttonLabel || t('close')}</PrimaryButton>
        </div>
      </div>
    </Overlay>
  );
};

export default localizable(OverlayMessage);



// WEBPACK FOOTER //
// ./src/app/components/MessageOverlay/OverlayMessage.jsx